import { Feather } from '@expo/vector-icons';
import { Container, ItemForm, ViewButton } from './style';
import PickerColorHex from '../../../components/PickerColorHex';
import { UploadImages } from '../../../components/UploadImages';
import { useEditMain } from './useEditMain';
import { ActivityIndicator, TextInput } from 'react-native-paper';
import { View } from 'react-native';
import THEME from '../../../config/theme';
import { useCustomTheme } from '../../../contexts/useCustomTheme';
import { TextAndTooltip } from '../../Brand/style';
import { TooltipCustom } from '../../../components/Tooltip';
import { StandardText, FooterText } from '../../../config/theme/globalStyles';
import { Text } from 'react-native';
import Button from '../../../components/Button';
import AdminInput from '../../../components/AdminInput';
import { ADMIN_COLORS, ADMIN_FONT } from '../../../config/theme/adminColors';
import { SectionCard, Field, FieldLabel } from '../../AdminPanel/Products/formStyles';
import { normalizeBannerLink } from '../../../utils/bannerLinks';

export function EditMain({ closeMenu, fullWidth }) {
  const {
    backgroundColor,
    setBackgroundColor,
    textTitleMain,
    setTextTitleMain,
    textApp,
    setTextApp,
    backgroundButtonColor,
    setBackgroundButtonColor,
    textButtonColor,
    setTextButtonColor,
    iconLockColor,
    setIconLockColor,
    iconColor,
    setIconColor,
    catalogFiltersColor,
    setCatalogFiltersColor,
    show,
    handleShowPicker,
    title,
    setTitle,
    subTitle,
    setSubTitle,
    isLoadingThemeInfo,
    isLoadingCustomizationInfo,
    isSavedColorsApp,
    setIsSavedColorsApp,
    linkImg1,
    setLinkImg1,
    linkImg2,
    setLinkImg2,
    linkImg3,
    setLinkImg3,
    updateNavigationLinks
  } = useEditMain();

  const { customColor } = useCustomTheme();

  function handleSave(newValueState) {
    setIsSavedColorsApp(newValueState);

    setTimeout(() => {
      setIsSavedColorsApp(false);
    }, 2000);
  }

  return (
    // `fullWidth`: dentro da folha do celular o painel ocupa a largura toda.
    // Ancorado no Menu (desktop) ele precisa da largura própria.
    <Container
      style={{
        width: fullWidth ? '100%' : 'min(32rem, 94vw)',
        backgroundColor: ADMIN_COLORS.surfaceSubtle,
      }}
    >
      <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingTop: 4, paddingBottom: 8 }}>
        <Text style={{ fontFamily: ADMIN_FONT, fontSize: 20, fontWeight: '700', color: ADMIN_COLORS.ink }}>
          Personalização
        </Text>
        <Feather
          name="x"
          size={24}
          onPress={closeMenu}
          color={ADMIN_COLORS.ink}
          style={{ alignSelf: 'flex-end', cursor: 'pointer' }}
        />
      </View>
      {isLoadingThemeInfo || isLoadingCustomizationInfo ? (
        <ActivityIndicator
          style={{
            flex: 1,
            backgroundColor: THEME.COLORS.BACKGROUND_ABOUT,
            justifyContent: 'center',
          }}
          color={
            customColor && customColor.primary
              ? customColor.primary
              : THEME.COLORS.PRIMARY_800
          }
        />
      ) : (
        <View>
          <SectionCard title="Logotipo e banners">
          <ItemForm style={{ height: '70px' }}>
            <TextAndTooltip>
              <FooterText textAlign="left" color="black">
                Logo (png)
              </FooterText>
              <TooltipCustom text="Logo que aparecerá no canto superior direto desta tela. Tamanho(px): recomendado usar 64x64 e limitado a 2MB. Formato: apenas imagens no formato .png são aceitas." />
            </TextAndTooltip>

            <UploadImages fileType="logoApp" />
          </ItemForm>
          <TextAndTooltip>
            <FooterText textAlign="left" color="black">
              Banner de fundo Desktop (png)
            </FooterText>
            <TooltipCustom text="Tamanho recomendado: 1920px-1080px e limitado a 2MB. Formato: somente imagens PNG são aceitas." />
          </TextAndTooltip>
          <ItemForm style={{ height: '70px' }}>
            <TextAndTooltip>
              <FooterText textAlign="left" color="#B1B1B1">
                Imagem 1
              </FooterText>
            </TextAndTooltip>

            <UploadImages fileType="imageApp" index={0} />
          </ItemForm>
          <ItemForm style={{ height: '70px' }}>
            <TextAndTooltip>
              <FooterText textAlign="left" color="#B1B1B1">
                Imagem 2 (opcional)
              </FooterText>
            </TextAndTooltip>

            <UploadImages fileType="imageApp" index={1} />
          </ItemForm>
          <ItemForm style={{ height: '70px' }}>
            <TextAndTooltip>
              <FooterText textAlign="left" color="#B1B1B1">
                Imagem 3 (opcional)
              </FooterText>
            </TextAndTooltip>

            <UploadImages fileType="imageApp" index={2} />
          </ItemForm>

          <TextAndTooltip>
            <FooterText textAlign="left" color="black">
              Banner de fundo Mobile (png)
            </FooterText>
            <TooltipCustom text="Tamanho recomendado: 768px-1024px e limitado a 2MB. Formato: somente imagens PNG são aceitas." />
          </TextAndTooltip>
          <ItemForm style={{ height: '70px' }}>
            <TextAndTooltip>
              <FooterText textAlign="left" color="#B1B1B1">
                Imagem 1
              </FooterText>
            </TextAndTooltip>

            <UploadImages fileType="imageAppMobile" index={0} />
          </ItemForm>
          <ItemForm style={{ height: '70px' }}>
            <TextAndTooltip>
              <FooterText textAlign="left" color="#B1B1B1">
                Imagem 2 (opcional)
              </FooterText>
            </TextAndTooltip>

            <UploadImages fileType="imageAppMobile" index={1} />
          </ItemForm>
          <ItemForm style={{ height: '70px' }}>
            <TextAndTooltip>
              <FooterText textAlign="left" color="#B1B1B1">
                Imagem 3 (opcional)
              </FooterText>
            </TextAndTooltip>

            <UploadImages fileType="imageAppMobile" index={2} />
          </ItemForm>
          </SectionCard>

          {/* Ao sair do campo, o link é completado com "https://" quando vem só
              o domínio. É a mesma normalização que o app aplica na hora de abrir
              — fazê-la aqui deixa o admin VER qual endereço será usado, em vez
              de descobrir depois que o banner não abre nada. */}
          <SectionCard title="Links de redirecionamento do banner">
            <Field>
              <FieldLabel>Link da Imagem 1 (opcional)</FieldLabel>
              <AdminInput
                placeholder="https://..."
                value={linkImg1}
                onChangeText={setLinkImg1}
                onBlur={() => setLinkImg1((link) => normalizeBannerLink(link))}
              />
            </Field>
            <Field>
              <FieldLabel>Link da Imagem 2 (opcional)</FieldLabel>
              <AdminInput
                placeholder="https://..."
                value={linkImg2}
                onChangeText={setLinkImg2}
                onBlur={() => setLinkImg2((link) => normalizeBannerLink(link))}
              />
            </Field>
            <Field style={{ marginBottom: 0 }}>
              <FieldLabel>Link da Imagem 3 (opcional)</FieldLabel>
              <AdminInput
                placeholder="https://..."
                value={linkImg3}
                onChangeText={setLinkImg3}
                onBlur={() => setLinkImg3((link) => normalizeBannerLink(link))}
              />
            </Field>
          </SectionCard>

          <SectionCard title="Textos em destaque sobre o banner">
            <Field>
              <FieldLabel>Título em destaque (opcional)</FieldLabel>
              <AdminInput
                placeholder="Escreva o texto em destaque aqui"
                value={title}
                onChangeText={(text) => setTitle(text)}
              />
            </Field>
            <Field style={{ marginBottom: 0 }}>
              <FieldLabel>Subtítulo em destaque (opcional)</FieldLabel>
              <AdminInput
                placeholder="Escreva o subtítulo em destaque aqui"
                value={subTitle}
                onChangeText={(text) => setSubTitle(text)}
              />
            </Field>
          </SectionCard>

          <SectionCard title="Cores">
          <ItemForm>
            <FooterText textAlign="left" color="black">Cor de fundo</FooterText>
            <PickerColorHex
              colorName={backgroundColor}
              props={{
                color: backgroundColor,
                onChange: setBackgroundColor,
              }}
              setShow={() =>
                handleShowPicker(
                  'showBackgroundColor',
                  !show.showBackgroundColor
                )
              }
              isShowPicker={show.showBackgroundColor}
              setChange={setBackgroundColor}
            />
          </ItemForm>
          <ItemForm>
            <FooterText textAlign="left" color="black">Cor do título e subtítulo em destaque</FooterText>
            <PickerColorHex
              colorName={textTitleMain}
              props={{
                color: textTitleMain,
                onChange: setTextTitleMain,
              }}
              setShow={() =>
                handleShowPicker('showTextTitleMain', !show.showTextTitleMain)
              }
              isShowPicker={show.showTextTitleMain}
              setChange={setTextTitleMain}
            />
          </ItemForm>
          <ItemForm>
            <FooterText textAlign="left" color="black">Cor dos textos em geral</FooterText>
            <PickerColorHex
              colorName={textApp}
              props={{
                color: textApp,
                onChange: setTextApp,
              }}
              setShow={() => handleShowPicker('showTextApp', !show.showTextApp)}
              isShowPicker={show.showTextApp}
              setChange={setTextApp}
            />
          </ItemForm>

          <ItemForm>
            <FooterText textAlign="left" color="black">Cor de fundo do botão</FooterText>
            <PickerColorHex
              colorName={backgroundButtonColor}
              props={{
                color: backgroundButtonColor,
                onChange: setBackgroundButtonColor,
              }}
              setShow={() =>
                handleShowPicker(
                  'showBackgroundButtonColor',
                  !show.showBackgroundButtonColor
                )
              }
              isShowPicker={show.showBackgroundButtonColor}
              setChange={setBackgroundButtonColor}
            />
          </ItemForm>
          <ItemForm>
            <FooterText textAlign="left" color="black">Cor do texto nos botões</FooterText>
            <PickerColorHex
              colorName={textButtonColor}
              props={{
                color: textButtonColor,
                onChange: setTextButtonColor,
              }}
              setShow={() =>
                handleShowPicker(
                  'showTextButtonColor',
                  !show.showTextButtonColor
                )
              }
              isShowPicker={show.showTextButtonColor}
              setChange={setTextButtonColor}
            />
          </ItemForm>

          <ItemForm>
            <FooterText textAlign="left" color="black">Ícone do cadeado</FooterText>
            <PickerColorHex
              colorName={iconLockColor}
              props={{
                color: iconLockColor,
                onChange: setIconLockColor,
              }}
              setShow={() =>
                handleShowPicker('showIconLock', !show.showIconLock)
              }
              isShowPicker={show.showIconLock}
              setChange={setIconLockColor}
            />
          </ItemForm>
          <ItemForm>
            <FooterText textAlign="left" color="black">Ícones do header</FooterText>
            <PickerColorHex
              colorName={iconColor}
              props={{
                color: iconColor,
                onChange: setIconColor,
              }}
              setShow={() =>
                handleShowPicker('showIconColor', !show.showIconColor)
              }
              isShowPicker={show.showIconColor}
              setChange={setIconColor}
            />
          </ItemForm>
          <ItemForm>
            <FooterText textAlign="left" color="black">Filtros da vitrine de produtos</FooterText>
            <PickerColorHex
              colorName={catalogFiltersColor}
              props={{
                color: catalogFiltersColor,
                onChange: setCatalogFiltersColor,
              }}
              setShow={() =>
                handleShowPicker('showCatalogFiltersColor', !show.showCatalogFiltersColor)
              }
              isShowPicker={show.showCatalogFiltersColor}
              setChange={setCatalogFiltersColor}
            />
          </ItemForm>
          </SectionCard>

          <ViewButton>
            <Button
              title={isSavedColorsApp ? "Salvo!" : "Salvar"}
              onPress={async () => {
                await updateNavigationLinks();
                handleSave(true);
              }}
              style={{
                cursor: "pointer",
                alignSelf: "center",
                backgroundColor: isSavedColorsApp
                  ? "#3FC380a0"
                  : customColor &&
                    customColor.button &&
                    customColor.button.backgroundApp
                    ? customColor.button.backgroundApp
                    : THEME.COLORS.PRIMARY_900,
              }}
            />
          </ViewButton>
        </View>
      )}
    </Container>
  );
}
